import {ACTIONS, type Execution} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import
import type {DataModelAPI} from '../../../dataModel/dataModel'
import {DATA_TYPES} from '../../../../constants/constants'

export class ActionExecution {
    constructor(private readonly dataModelAPI: DataModelAPI) {}

    public getDashboardPanelExecutor = (actionId: string): Execution => {
        const dashboard = this.dataModelAPI.getItem(actionId, DATA_TYPES.data)

        return {
            actionType: ACTIONS.ACTION_TYPE.panel,
            panel: {
                panelType: ACTIONS.PANEL_TYPE.inline,
                inline: {
                    displayName: dashboard.title,
                    referenceId: actionId,
                    contentType: ACTIONS.PANEL_CONTENT_TYPE.url
                }
            }
        }
    }

    public getCustomPanelExecutor = (actionId: string): Execution => {
        return {
            actionType: ACTIONS.ACTION_TYPE.panel,
            panel: {
                panelType: ACTIONS.PANEL_TYPE.panelId,
                panelId: actionId
            }
        }
    }

    private getDesignFields = (): Execution => {
        return {
            actionType: ACTIONS.ACTION_TYPE.forward,
            forward: {
                actionName: ACTIONS.ACTION_NAME.design,
                elementPath: '.self'
            }
        }
    }

    public createFields = (type: string) => {
        switch (type) {
            case 'design':
                return this.getDesignFields()
        }
    }
}
